import { path } from 'ramda'

export const randomNum = (min, max) => {
  return Math.floor(Math.random() * (max - min)) + 1
}

export const textFieldValue = path(['target', 'value'])
